import React, { useEffect, useState } from 'react';

import {
  Button,
  Card, Col, Form, Row, Select,
} from 'antd';

import {
  FormItemSelect,
  FormItemInput,
  FormItemRangePicker,
} from '../../../components/ant-wrapper/form-item';
import { ESTADO_CIVIL_FIELDS, SEXO_FIELDS } from '../../../components/utils';
import { getClinicas } from '../../../services/clinicas';
import { getCidades, getDistricts } from '../../../services/districts';
import { getPacientes } from '../../../services/pacientes';
import { getProfissionais } from '../../../services/profissional';
import { gerarRelatorioAtendimento, gerarRelatorioPacientes } from '../../../services/relatorios';
import { getUnidades } from '../../../services/unidades';

const { Option } = Select;
const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 18 },
};
const cardStyle = { borderColor: 'white' };
export default function RelatorioPacientes() {
  const [form] = Form.useForm();
  const [distritos, setDistritos] = useState([]);
  const [cidades, setCidades] = useState([]);

  const onSubmit = async (values) => {
    await gerarRelatorioPacientes(values);
  };
  const getAllDistricts = async () => {
    const data = await getDistricts('', '', false);
    setDistritos(data);
    const cidadesData = await getCidades();
    setCidades(cidadesData);
  };

  useEffect(() => {
    getAllDistricts();
  }, []);
  return (
    <div style={{ width: '100%' }}>
      <Form
        form={form}
        name="register"
        onFinish={onSubmit}
        scrollToFirstError
        {...formItemLayout}
      >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <FormItemInput name="nome" label="Nome" />

          </Col>
          <Col span={8}>
            <FormItemSelect
              name="distrito"
              label="Distrito"
              items={distritos}
              itemsLabel={['nome']}
              stringfyValue
            />
          </Col>
          <Col span={8}>
            <FormItemSelect
              name="cidade"
              label="Cidade"
              items={cidades}
              itemsLabel="cidade"
              itemsValue="cidade"
            />
          </Col>
          <Col span={8}>
            <FormItemSelect
              name="sexo"
              label="Sexo"
              items={SEXO_FIELDS}
            />
          </Col>
          <Col span={8}>
            <FormItemSelect
              name="estado_civil"
              label="Estado civil"
              items={ESTADO_CIVIL_FIELDS}
            />
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Enviar
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
